import { BOROS, DISTRICTS } from './lookup-tables';

export function sortCandidates(candidates) {
  let incumbent = _.filter(candidates, ['incumbent', 'y']);
  let challengers = _.sortBy(_.reject(candidates, ['incumbent', 'y']), 'lastName');
  let sorted = incumbent.concat(challengers);
  return sorted;
}

export function sortRaces({ district, races, boros }) {
  let sorted = [];
  
  // citywide races include mayor, public advocate and comptroller
  sorted.push(races.mayor, races.comptroller, races['public-advocate']);
  
  if (!boros.length) {
    Object.keys(BOROS).forEach(boroKey => {
      if (DISTRICTS[BOROS[boroKey]].includes(Number(district))) {
        boros.push(BOROS[boroKey]);
      }
    });
  }
  
  insertRaces(sorted, races, boros);

  if (races[`district-${district}`]) {
    sorted.push(races[`district-${district}`]);
  }
  return sorted;
}

function insertRaces(sorted, races, boros) {
  if (!boros.length) {
    return false;
  }
  let boro = boros[0];
  
  switch(boro) {
  case BOROS.BROOKLYN:
    sorted.push(races['brooklyn-borough-president']);
    break;
  case BOROS.BRONX:
    sorted.push(races['bronx-borough-president']);
    break;
  case BOROS.STATEN_ISLAND:
    sorted.push(races['staten-island-borough-president']);
    break;
  case BOROS.MANHATTAN:
    sorted.push(races['manhattan-borough-president']);
    break;
  case BOROS.QUEENS:
    sorted.push(races['queens-borough-president']);
    break;
  }
  insertRaces(sorted, races, boros.slice(1));
}



// WEBPACK FOOTER //
// ./app/src/js/lib/sorting.js